import api from './api';

// Fallback for environments where the PD-2651 backend hasn't deployed yet.
// Reads the legacy `/categories-and-actions` endpoint and synthesizes a
// JSONAPI shape that matches the new `/categories` response — using the
// category NAME as a stand-in `id` so the page can keep rendering. Once
// the new endpoint is live, the primary path takes over and this branch
// stops firing.
const fetchCategoriesFromLegacy = async () => {
  try {
    const response = await api.get('/categories-and-actions');
    const rows = response.data?.data || [];
    const data = rows.map((entry) => ({
      id: entry.attributes.category,
      type: 'categories',
      attributes: { name: entry.attributes.category },
    }));
    return { data, fromLegacy: true };
  } catch (legacyErr) {
    return { errors: legacyErr.response?.data?.errors };
  }
};

const listCategories = async ({ page = null, limit = null } = {}) => {
  try {
    const params = {};
    if (page) params['page[number]'] = page;
    if (limit) params['page[size]'] = limit;
    const response = await api.get('/categories', { params });
    return { data: response.data.data };
  } catch (e) {
    if (e.response?.status === 404) return fetchCategoriesFromLegacy();
    return { errors: e.response?.data?.errors };
  }
};

const createCategory = async (attributes) => {
  try {
    const response = await api.post('/categories', {
      data: { type: 'categories', attributes },
    });
    return { data: response.data.data };
  } catch (e) {
    return { errors: e.response?.data?.errors };
  }
};

const updateCategory = async (uuid, attributes) => {
  try {
    const response = await api.patch(`/categories/${uuid}`, {
      data: { type: 'categories', attributes },
    });
    return { data: response.data.data };
  } catch (e) {
    return { errors: e.response?.data?.errors };
  }
};

const deleteCategory = async (uuid) => {
  try {
    await api.delete(`/categories/${uuid}`, { data: {} });
    return { ok: true };
  } catch (e) {
    return { errors: e.response?.data?.errors, status: e.response?.status };
  }
};

export default {
  listCategories,
  createCategory,
  updateCategory,
  deleteCategory,
};
